export const apiUrl = 'https://wallet-server-ttcy.onrender.com/api';

